import { consumeContext } from "@/lib/consume/context"
import { consumeFromGivenScreenWidth } from "@/lib/consume/fromGivenScreenWidth"
import { Geolocation } from "@/lib/geolocation"

import { BookingSearchDropdownComponent } from "./component"

export const BookingSearchDropdownConsumer = consumeFromGivenScreenWidth(1550)(
  consumeContext({
    Context: Geolocation.Context,
    provideTo: `geolocation`,
  })(BookingSearchDropdownComponent)
)
